import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgCustomPDFFile = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "Represents a Portable Document Format (.pdf) file",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="32"
    height="41"
    viewBox="0 0 32 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M31.4099 9.26001V37.61C31.4099 38.71 30.5099 39.61 29.4099 39.61H6.62988C5.52988 39.61 4.62988 38.71 4.62988 37.61V2.51001C4.62988 1.41001 5.52988 0.51001 6.62988 0.51001H22.7999L31.4099 9.26001Z"
      fill="white"
    />
    <path
      d="M29.4099 40.1H6.62988C5.24988 40.1 4.12988 38.98 4.12988 37.6V2.5C4.12988 1.12 5.24988 0 6.62988 0H22.7999C22.9299 0 23.0599 0.0500015 23.1599 0.150002L31.7699 8.9C31.8599 8.99 31.9099 9.12 31.9099 9.25V37.6C31.9099 38.98 30.7899 40.1 29.4099 40.1ZM6.62988 1C5.79988 1 5.12988 1.67 5.12988 2.5V37.6C5.12988 38.43 5.79988 39.1 6.62988 39.1H29.4099C30.2399 39.1 30.9099 38.43 30.9099 37.6V9.46L22.5899 1H6.62988Z"
      fill="#C4CBD0"
    />
    <path
      d="M30.8698 9.25998H24.7998C23.6998 9.25998 22.7998 8.35998 22.7998 7.25998V1.16998"
      fill="white"
    />
    <path
      d="M30.8698 9.75998H24.7998C23.4198 9.75998 22.2998 8.63998 22.2998 7.25998V1.16998C22.2998 0.889983 22.5198 0.669983 22.7998 0.669983C23.0798 0.669983 23.2998 0.889983 23.2998 1.16998V7.25998C23.2998 8.08998 23.9698 8.75998 24.7998 8.75998H30.8698C31.1498 8.75998 31.3698 8.97998 31.3698 9.25998C31.3698 9.53998 31.1498 9.75998 30.8698 9.75998Z"
      fill="#C4CBD0"
    />
    <path
      d="M26.03 31.66H1.2C0.540005 31.66 0 31.12 0 30.46V16.52C0 15.86 0.540005 15.32 1.2 15.32H26.03C26.69 15.32 27.23 15.86 27.23 16.52V30.46C27.23 31.12 26.7 31.66 26.03 31.66Z"
      fill="#E29119"
    />
    <path
      d="M4.55043 26.9999V19.7272H7.55469C8.0992 19.7272 8.56913 19.8337 8.96449 20.0468C9.36222 20.2575 9.6688 20.5523 9.88423 20.931C10.0997 21.3075 10.2074 21.7454 10.2074 22.245C10.2074 22.7469 10.0973 23.186 9.87713 23.5624C9.65933 23.9365 9.34801 24.2265 8.94318 24.4325C8.53835 24.6384 8.05777 24.7414 7.50142 24.7414H5.64773V23.3565H7.17472C7.43987 23.3565 7.66122 23.3103 7.83878 23.218C8.0187 23.1256 8.15483 22.9966 8.24716 22.8309C8.33949 22.6628 8.38565 22.4675 8.38565 22.245C8.38565 22.0201 8.33949 21.8259 8.24716 21.6626C8.15483 21.4969 8.0187 21.369 7.83878 21.2791C7.65885 21.1891 7.4375 21.1441 7.17472 21.1441H6.30824V26.9999H4.55043ZM13.7621 26.9999H11.0739V19.7272H13.7585C14.4995 19.7272 15.1375 19.8728 15.6726 20.164C16.21 20.4528 16.6243 20.8695 16.9155 21.414C17.2067 21.9561 17.3523 22.6048 17.3523 23.36C17.3523 24.1176 17.2067 24.7686 16.9155 25.3131C16.6267 25.8577 16.2135 26.2755 15.6761 26.5667C15.1387 26.8555 14.5007 26.9999 13.7621 26.9999ZM12.8317 25.5014H13.6946C14.1018 25.5014 14.4463 25.4327 14.728 25.2954C15.0121 25.1557 15.2263 24.9296 15.3707 24.6171C15.5175 24.3023 15.5909 23.8832 15.5909 23.36C15.5909 22.8368 15.5175 22.4202 15.3707 22.11C15.224 21.7975 15.0073 21.5726 14.7209 21.4353C14.4368 21.2956 14.0864 21.2258 13.6697 21.2258H12.8317V25.5014ZM18.3786 26.9999V19.7272H23.343V21.1548H20.1364V22.6462H23.027V24.0774H20.1364V26.9999H18.3786Z"
      fill="white"
    />
  </svg>
);

const CustomPDFFile = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgCustomPDFFile />
  </BaseIcon>
);

export default CustomPDFFile;
